import React from 'react'

import type { IControlProps } from 'components/controls/Field/Field.types'
import type { IRadioProps } from 'components/uiKit/Radio'
import Radio from 'components/uiKit/Radio'

/** @deprecated use [FormKit](../../../../components/formKit/fields/index.ts) */
const FieldRadio: React.FC<IControlProps<IRadioProps<string>>> = ({
  value,
  onChange,
  name,
  defaultValue,
  ...rest
}) => {
  const handleOnChange = (value: IRadioProps<string>['value']) => {
    onChange({ value, name })
  }

  return (
    <Radio
      {...rest}
      name={String(name)}
      onChange={handleOnChange}
      value={value ?? (defaultValue as string)}
    />
  )
}

export default FieldRadio
